import { CloseOutlined } from "@ant-design/icons";
import { Button, Form, Input } from "antd";
import dayjs from "dayjs";
import { FunctionComponent, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import DatePicker from "../../shared/date-picker";
import TagList, { TagWithMeta } from "./tag-list";
interface FilterData {
  from?: string;
  to?: string;
  name?: string;
  url?: string;
}

interface GearFilterProps {}

const GearFilter: FunctionComponent<GearFilterProps> = () => {
  const [form] = Form.useForm();
  const [formValue, setFormValue] = useState<any>();
  const [search, setSearch] = useSearchParams();

  useEffect(() => {
    const tmp: any = {};
    if (search.get("name")) {
      tmp.name = search.get("name");
    }
    if (search.get("url")) {
      tmp.url = search.get("url");
    }
    if (search.get("from")) {
      tmp.from = dayjs(search.get("from"), "YYYY-MM-DD");
    }
    if (search.get("to")) {
      tmp.to = dayjs(search.get("to"), "YYYY-MM-DD");
    }
    if (search.get("tags")) {
      tmp.tags = decodeURIComponent(search.get("tags") || "")
        .split(",")
        .map((e) => {
          const [id, name] = e.split("|");
          return { id, name };
        });
    }
    form.setFieldsValue(tmp);
    setFormValue(tmp);
  }, []);
  const update = (data: any) => {
    const query: any = {};
    if (data.name) {
      query.name = data.name;
    }
    if (data.url) {
      query.url = data.url;
    }
    if (data.from) {
      query.from = data.from.format("YYYY-MM-DD");
    }
    if (data.to) {
      query.to = data.to.format("YYYY-MM-DD");
    }
    if (Array.isArray(data.tags)) {
      query.tags = encodeURIComponent(
        (data.tags as TagWithMeta[])
          .filter((e) => !e.deleted)
          .map((t) => `${t.id}|${t.name}`)
          .join(",")
      );
    }
    setSearch(query);
  };
  const onReset = () => {
    setSearch({});
    form.resetFields();
  };

  const hasValue = Object.keys(form.getFieldsValue()).some((key) =>
    form.getFieldValue(key)
  );
  return (
    <Form
      layout="inline"
      form={form}
      onFinish={update}
      onValuesChange={(_, val) => setFormValue(val)}
    >
      <Form.Item name="from">
        <DatePicker
          placeholder={"Date From"}
          disabledDate={(d: any) =>
            formValue?.to ? d.isAfter(formValue?.to) : false
          }
        />
      </Form.Item>
      <Form.Item name="to">
        <DatePicker
          placeholder={"Date to"}
          disabledDate={(d: any) =>
            formValue?.from ? d.isBefore(formValue?.from) : false
          }
        />
      </Form.Item>
      <Form.Item name="name">
        <Input placeholder="Gear Name" allowClear />
      </Form.Item>

      <Form.Item name="url">
        <Input placeholder="Gear Url" allowClear />
      </Form.Item>
      <Form.Item name="tags">
        <TagList placeholder="Select Tags" />
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit">
          Apply Filter
        </Button>
      </Form.Item>
      {hasValue && (
        <Form.Item>
          <Button type="link" icon={<CloseOutlined />} onClick={onReset}>
            Clear
          </Button>
        </Form.Item>
      )}
    </Form>
  );
};

export default GearFilter;
